import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { ProfileAdmin } from './components/ProfileAdmin';

const Profile = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30, color:"#024b82" }}>Gestión de Perfiles</h3>
      </Col>
    </Row>
    <Row>
        <ProfileAdmin />
    </Row>
  </Container>
);

export default Profile;